import { createArrayWithBracesParser } from '../inboundParsers';
import { playerIdNameParser } from './utils/playerInboundUtils';
export const SET_ALL_FRIENDS_PAYLOAD_DEFINITION = {
    isRawParam: true,
    definitionParts: [{ name: 'allFriends', parser: createArrayWithBracesParser(playerIdNameParser) }]
};
